import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Container } from "react-bootstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Modal from "react-modal";
import CommonStructured from "../../common-components/CommonStructured";
import CmnFilters from "../../lead-management/common/CmnFilters";
import {
  fetchMembershipTransferData,
  fetchMembershipTransferRequestData,
} from "../../../redux/transfer-reducers/transferSlice";
import MembershipTransferListings from "./MembershipTransferListings";
import MembershipTransferForm from "./MembershipTransferForm";
import MembershipTransferRequestListings from "./transfer-request/MembershipTransferRequestListings";
import MembershipTransferRequestForm from "./transfer-request/MembershipTransferRequestForm";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import PlanDetails from "./plan-detail/PlanDetails";
import ViewDetails from "./plan-detail/ViewDetails";
import HelmetWrapper from "../../../HelmetWrapper";

const MembershipTransferStructure = ({ userInfoData }) => {
  const dispatch = useDispatch();

  const isAdminCluster =
    userInfoData?.account_type === "admin" ||
    userInfoData?.account_type === "cluster_manager";

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: "",
    selAddedby: !isAdminCluster
      ? {
          label: userInfoData?.name || "",
          value: userInfoData?.uid || userInfoData?.user_id || "",
        }
      : "",
    selectedApprovalStatus: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_from: allFilters.selectedGym?.value || "",
    transfered_by: allFilters.selAddedby?.value || "",
    status: allFilters.selectedApprovalStatus?.value || "",
    start_date: allFilters.leadAddDateFrom || "",
    end_date: allFilters.leadAddDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const iniModvalues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const handleTabSelect = (index) => {
    setSelectedTab(index);
    setIsPage(0);
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const getMembershipTransferRequestList = () => {
    dispatch(
      fetchMembershipTransferRequestData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  function getMembershipTransferList(filters) {
    dispatch(
      fetchMembershipTransferData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getCombineReload() {
    getMembershipTransferList(filters);
    getMembershipTransferRequestList(filters);
  }

  useEffect(() => {
    getMembershipTransferRequestList(filters);
    getMembershipTransferList(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_from: allFilters.selectedGym?.value || "",
      transfered_by: allFilters.selAddedby?.value || "",
      status: allFilters.selectedApprovalStatus?.value || "",
      start_date: allFilters.leadAddDateFrom || "",
      end_date: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selAddedby,
    allFilters.selectedApprovalStatus,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Membership Transfer">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Modal"
          ariaHideApp={false}>
          <div
            className={`createNewCTOModalContainer ${
              modValues.modName === "view_details"
                ? "mod-width-70p"
                : "mod-width-50p"
            }`}>
            <ModalHeadAndClose
              title={
                modValues.modName === "approval"
                  ? "Approve/Reject Membership Transfer Request"
                  : modValues.modName === "add"
                  ? "Membership Transfer"
                  : modValues.modName === "plan-details"
                  ? modValues.rowData?.user_from_name
                  : modValues.modName?.replace(/_/g, " ")
              }
              onClose={onCloseModal}
            />

            {modValues.modName === "add" ? (
              <MembershipTransferForm
                userInfoData={userInfoData}
                rowData={modValues.rowData}
                closeModal={onCloseModal}
                callFunction={getCombineReload}
              />
            ) : modValues.modName === "approval" ? (
              <MembershipTransferRequestForm
                userInfoData={userInfoData}
                rowData={modValues.rowData}
                callFunction={getCombineReload}
                onCloseModal={onCloseModal}
                from="membership-transfer"
              />
            ) : modValues.modName === "remarks" ? (
              <div className="discussionModalMessage mt30">
                <p className="message">
                  {modValues.rowData?.aprv_rej_remarks ||
                    "No Content Available"}
                </p>
              </div>
            ) : modValues.modName === "plan-details" ? (
              <PlanDetails rowData={modValues.rowData} />
            ) : modValues.modName === "view_details" ? (
              <ViewDetails
                rowData={modValues.rowData}
                isMembershipTransfer={true}
                isPaymentLinkListings={modValues.isPaymentLinkListings}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Membership Transfer"}
              createBtnTxt={"➤ New Membership Transfer"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "add",
                }))
              }
              isReload={getCombineReload}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from={"membership-transfer"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={false}
              searchPlaceHolder="Search by member info"
              clickedCard="membership-transfer"
              selectedTab={selectedTab}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="discount-payments-tabs bgTransParent odm-wati-container">
              <Tabs onSelect={handleTabSelect}>
                <TabList>
                  <Tab>Membership Transfer</Tab>
                  <Tab>Membership Transfer Request</Tab>
                </TabList>

                <TabPanel>
                  <MembershipTransferListings
                    isPage={isPage}
                    setIsPage={setIsPage}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                    setModValues={setModValues}
                  />
                </TabPanel>
                <TabPanel>
                  <MembershipTransferRequestListings
                    isPage={isPage}
                    setIsPage={setIsPage}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                    setModValues={setModValues}
                    userInfoData={userInfoData}
                  />
                </TabPanel>
              </Tabs>
            </div>
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default MembershipTransferStructure;
